<template>
  <DSOptionLabel
    :option="props.option"
    :disabled="props.disabled"
    :selected="model === props.option.value"
    :direction="props.direction"
    :has-error="hasErrors"
    :class="DS_RADIO_BUTTON_CLASSES.Root"
  >
    <template #default="defaultSlotAttributes">
      <input
        ref="inputRef"
        type="radio"
        :name="props.name"
        :value="optionValue"
        :checked="model === props.option.value"
        :disabled="props.disabled"
        :class="[DS_RADIO_BUTTON_CLASSES.Input, defaultSlotAttributes.class]"
        :data-cy="`ds-radio__input--${props.option.value || 'null'}`"
        @change="setModel(($event?.target as HTMLInputElement)?.value)"
        @focus="emit('focus', $event)"
        @blur="emit('blur', $event)"
      />
    </template>
  </DSOptionLabel>
</template>

<script setup lang="ts">
import { computed, ref } from "vue";
import type { DSRadioButtonEmits } from "../types/emits";
import { useDSInput } from "@/src/design_system/form_elements/shared/composables/useDSInput";
import { DSRadioModelValue } from "@/src/design_system/form_elements/radio/shared/types/props";
import DSOptionLabel from "@/src/design_system/form_elements/shared_modules/option_label/components/DSOptionLabel.vue";
import { DS_DIRECTION } from "@/src/design_system/shared/types/direction";
import { DSRadioButtonProps } from "@/src/design_system/form_elements/radio/shared_modules/radio_button/types/props";
import { DS_RADIO_BUTTON_CLASSES } from "@/src/design_system/form_elements/radio/shared_modules/radio_button/constants/classes";

const props = withDefaults(defineProps<DSRadioButtonProps>(), {
  disabled: false,
  direction: DS_DIRECTION.Horizontally,
  hasError: false,
});

const model = defineModel<DSRadioModelValue>();
const emit = defineEmits<DSRadioButtonEmits>();
const inputRef = ref<HTMLInputElement>();
const { focus, blur } = useDSInput(inputRef);

defineExpose({ focus, blur });

const hasErrors = computed(() => props.hasError || !!props.errorMessages?.length);

const optionValue = computed(() => {
  return props.option.value ?? "";
});

const setModel = (value: DSRadioModelValue) => {
  model.value = value || null;
};
</script>
